import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const services = createReducer(
  {
    list: [],
    categories: [],
  },
  {
    [types.GET_SERVICES_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });

      return newState;
    },
    [types.GET_SERVICES_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        list: action.services,
        staffMembers: action.staffMembers,
        loading: false,
      });
      return newState;
    },
    [types.GET_SERVICES_FAIL](state) {
      const newState = Object.assign({}, state, {
        list: [],
        loading: false,
      });

      return newState;
    },
    [types.SET_SERVICE_CATEGORIES](state, action) {
      const newState = Object.assign({}, state, {
        categories: action.categories,
      });
      return newState;
    },
  },
);

export { services as default };
